import { forwardRef } from "react";

import {
  SONNER_CLOSE_CLASS,
  type TSonnerCloseProps,
} from "@/ui/components/feedback/Sonner/Sonner.config";
import { Icon } from "@/ui/components/primitives/Icon";
import { cn } from "@/ui/lib/utils";
import { useSonner } from "./useSonner";

export const SonnerClose = forwardRef<HTMLButtonElement, TSonnerCloseProps>(
  (
    {
      className,
      type = "button",
      "aria-label": ariaLabel,
      ...props
    },
    ref,
  ) => {

    const { dismissLabel } = useSonner();

    return (
      <button
        {...props}
        ref={ref}
        type={type}
        aria-label={ariaLabel || dismissLabel}
        data-component="SonnerClose"
        className={cn(SONNER_CLOSE_CLASS, className)}
      >
        <Icon icon="cross" size="sm" aria-hidden="true" />
      </button>
    );
  },
);

SonnerClose.displayName = "SonnerClose";
